"use client";

import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { H3 } from "@/components/ui/heading";

export function FlowReviewCategory({
  title,
  editLabel = "Edit",
  onEdit,
  children,
}: {
  title: string;
  editLabel?: string;
  onEdit?: () => void;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-3">
        <H3 className="text-xl text-muted-foreground">{title}</H3>
        {onEdit ? (
          <Button type="button" variant="outline" onClick={onEdit}>
            {editLabel}
          </Button>
        ) : null}
      </div>
      {children}
    </section>
  );
}

export function FlowReviewItem({
  label,
  value,
  className,
}: {
  label: string;
  value?: string | boolean | null;
  className?: string;
}) {
  const text =
    typeof value === "boolean" ? (value ? "Yes" : "No") : value || "—";

  return (
    <div className={className}>
      <div className="text-sm font-semibold opacity-30">{label}</div>
      <div className="font-semibold text-muted-foreground">{text}</div>
    </div>
  );
}

export function FlowReviewContainer({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col gap-8 rounded-md bg-foreground/3 px-8 py-6">
      {children}
    </div>
  );
}
